import axios, { AxiosPromise } from 'axios';
import {
  ICancelEventRegisterReq,
  IGetPaymentRefunds,
  IGetRefundDetail,
  IGetRefundedDetailOrdersTodo,
  IGetRefundedItemsTodo,
  IGetRefundedOrdersTodo,
  IGetRefundStats,
  IGetRetiredStudentsTodo,
  IGetRetiredStudentTodo,
  IPaymentRefundParams,
  IRefundStatsParams,
  IRetiredStudentReq,
  ISubmitAbsenceRefundReq,
} from '../models/refunds.model';
import QueryString from 'qs';
import { IPartialRefundReq } from '../models/payments.model';
import { IResponse } from '../models/common.api.model';

const uri = '/mgmt/refunds';
const serviceUri = '/service/refunds';

export const getRefundedDetailListOrdersTodo = (
  memberCode: string,
): AxiosPromise<IGetRefundedDetailOrdersTodo> => {
  return axios.get(`${serviceUri}/detail-list/todo?memberCode=${memberCode}`);
};

export const getRefundedOrdersTodo = (
  memberCode: string,
): AxiosPromise<IGetRefundedOrdersTodo> => {
  return axios.get(`${serviceUri}/list/todo?memberCode=${memberCode}`);
};

export const getRefundedItemsTodo = (
  refundNo: number,
): AxiosPromise<IGetRefundedItemsTodo> => {
  return axios.get(`${serviceUri}/detail/${refundNo}/todo`);
};

export const refundOrder = (data: { refundNos: number[] }): AxiosPromise => {
  return axios.post(`${uri}/todo`, data);
};

export const getRetiredStudentsTodo = (
  campusCode: string,
): AxiosPromise<IGetRetiredStudentsTodo> => {
  return axios.get(`${uri}/calculate/todo?campusCode=${campusCode}`);
};

export const getRetiredStudentTodo = (
  calculateCode: number,
): AxiosPromise<IGetRetiredStudentTodo> => {
  return axios.get(`${uri}/calculate/refunds/${calculateCode}/todo`);
};

export const saveRetiredStudentTodo = (
  calculateCode: number,
  data: IRetiredStudentReq,
): AxiosPromise => {
  return axios.put(`${uri}/amount/${calculateCode}/todo`, data);
};

export const completeRetireTodo = (calculateCode: number): AxiosPromise => {
  return axios.put(`${uri}/amount/${calculateCode}/complete/todo`);
};

export const checkAbsenceRefunds = (
  data: ISubmitAbsenceRefundReq,
): AxiosPromise<IResponse<boolean>> => {
  return axios.post(`${uri}/attend-check`, data);
};

export const submitAbsenceRefunds = (
  data: ISubmitAbsenceRefundReq,
): AxiosPromise => {
  return axios.post(`${uri}/attend`, data);
};

export const submitAbsenceRefundResotre = (attendCode: number): AxiosPromise => {
  return axios.put(`${uri}/attend/admin/restore/${attendCode}`);
};

export const getPaymentRefunds = (
  params: IPaymentRefundParams,
): AxiosPromise<IGetPaymentRefunds> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/list?${qsParams}`);
};

export const getRefundDetail = (
  refundNo: number,
): AxiosPromise<IGetRefundDetail> => {
  return axios.get(`${uri}/detail/${refundNo}`);
};

export const getRefundStats = (
  params: IRefundStatsParams,
): AxiosPromise<IGetRefundStats> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/tuition?${qsParams}`);
};

// legacy

export const cancelEntranceExamWithRefundTodo = (
  platRequireCode: number,
): AxiosPromise => {
  return axios.post(`${uri}/plat-require/${platRequireCode}/todo`);
};

export const cancelEventRegister = (
  data: ICancelEventRegisterReq,
): AxiosPromise => {
  return axios.post(`${uri}/event-require`, data);
};

export const createPartialRefund = (data: IPartialRefundReq): AxiosPromise => {
  return axios.post(`${uri}/partial-refund`, data);
};